import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        VChip,
        {
          attrs: {
            value: _setup.translatedSelectedText,
            color: _setup.chipColor,
            "text-color": _setup.chipTextColor,
          },
          on: { click: _setup.handleClickFilter },
        },
        [
          _c(VIcon, [_vm._v("\n      ui-icon-filter\n    ")]),
          _vm._v(" "),
          _c("div", { staticClass: "mx-2" }, [
            _vm._v(
              "\n      " + _vm._s(_setup.translatedSelectedText) + "\n    "
            ),
          ]),
          _vm._v(" "),
          _c(
            VIcon,
            {
              attrs: { size: "16" },
              on: { click: _setup.handleClickCloseFilter },
            },
            [_vm._v("\n      " + _vm._s(_setup.closeIcon) + "\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }